import formSaga from "@common/store/form/form.saga";
import breadCrumb from "@common/store/breadcrumb/breadcrumb.saga";
import address from "@common/components/address/store/address.saga";
import addressMultiple from "@common/components/addressMultiple/store/addressMultiple.saga";
import steppers from "@common/components/steppers/store/steppers.saga";
import upload from "@common/components/upload/store/upload.saga";

export default [formSaga, breadCrumb, address, addressMultiple, steppers, upload];
